import * as React from 'react';

import { cn } from '@/utils/utils_client';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  iconStart?: React.ReactNode;
  iconEnd?: React.ReactNode;
  wrapperClassName?: string;
}

export const UI_PRIMITIVE__input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, iconStart, iconEnd, onChange, wrapperClassName = '', ...props }, ref) => {
    return (
      <div className={`relative w-full ${wrapperClassName}`}>
        {iconStart && <div className="absolute flex left-3 top-1/2 -translate-y-1/2 text-muted-foreground items-center">{iconStart}</div>}
        <input
          className={cn(
            `   flex h-10 w-full rounded-md border border-input bg-background py-2 text-base ring-offset-background 
              file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground 
              placeholder:text-component-item
              focus-primary
              cursor-text
              disabled:cursor-not-allowed disabled:opacity-50 md:text-sm px-3`,
            iconStart && '!pl-10',
            iconEnd && '!pr-10',
            className,
          )}
          {...{ onChange, type }}
          ref={ref}
          {...props}
        />
        {iconEnd && <div className="absolute flex right-3 top-1/2 -translate-y-1/2 text-muted-foreground items-center">{iconEnd}</div>}
      </div>
    );
  },
);
UI_PRIMITIVE__input.displayName = 'Input';
